<template>
  <h4>Recurring Payment Authorization</h4>
  <div class="disclaimer-modal">
    <p>
      <strong
        >AGREEMENT TO PAY AND AUTHORIZATION FOR RECURRING ACH DEBITS OR CREDIT
        CARD DEBITS</strong
      >
    </p>
    <p>
      <strong>1.&nbsp; Agreement to Pay.</strong><strong>&nbsp;&nbsp;</strong>By
      clicking below, you authorize the payee, American Bankers Insurance
      Company of Florida (“ABIC”) to debit your bank account or charge your
      credit card for the amount(s) and at the frequency and date set forth in
      this site or this Agreement.&nbsp; For recurring debits, an automatic
      withdrawal will be made in the amount of the balance due on your bill one
      (1) day prior to the invoice due date.&nbsp; In the event an initial
      payment or a renewal payment is rejected by your financial institution for
      insufficient funds, the policy will be deemed void and no coverage will be
      afforded to you, subject to applicable state law.
    </p>
    <p>
      <strong>2. Termination Clause:&nbsp;</strong>This Agreement will remain in
      in full force and effect until either party terminates this Agreement,
      which either party may do at any time upon prior written notice to the
      other party, which notice will be effective at the time of its receipt by
      by the other party, although the effectiveness of any termination notice
      received by ABIC within ten (10) days of any payment date may, at the
      election of ABIC, be delayed until after such payment. If you wish to
      terminate this Agreement, you must send a confirmation of termination to
      rentersmail@assurant.com or mailed to American Bankers Insurance Company
      of Florida, P.O Box 23852, Network Place, Chicago IL 60673-1238. &nbsp;If
      recurring payment from your credit card, checking account or savings
      account is rejected by your financial institution, ABIC will provide
      written notification to you and may terminate this Agreement.
    </p>
    <p>
      <strong>3. Miscellaneous:</strong>&nbsp;ABIC shall not be liable to you
      for any special, incidental or consequential damages arising from any
      breach of the terms and conditions of this Agreement, or as a result of
      any delay, error or omission in any authorized recurring debit entry to be
      be made, or from any act or omission of any financial institution,
      electronic funds transfer system, credit card issuer, operator or third
      party service provider, even if ABIC has been advised of the possibility
      of such damages. Each party shall bear all of the respective fees and
      other charges assessed by its designated financial institution(s). If an
      authorized recurring debit entry from your applicable account is rejected
      and no other provision is made for payment on or before the due date,
      date, payment will be considered delinquent. ABIC will have no obligation
      to provide notice of delinquency to you. ABIC reserves the right: (a) to
      adjust future authorized recurring debit entries from your account if any
      authorized recurring debit entry previously made is found to be
      duplicative, processed incorrectly, not at all, in excess of, or less than
      the required amount, (b) to choose the system used to process automatic
      bank or credit card debit entries and any third-party service provider it
      may use, and (c) to initiate debit or payment entries and adjustments from
      any authorized recurring debit entries made in error. ABIC is entitled to
      rely upon the information supplied by you on this website. Each automatic
      debit from your credit card, checking account or savings account, as
      applicable, will be made in accordance with the information you have
      provided in this enrollment form, or as any person purporting to represent
      you may otherwise specify in written notice received by ABIC. ABIC will
      not be responsible for any loss arising by reason of any error, mistake or
      fraud with regard to such information and shall be under no obligation to
      verify the authority of any person who purports to act on your
      behalf.&nbsp;
    </p>
  </div>
</template>
